import styled from 'styled-components';

interface ContainerProps {
  bg: string;
}

const Container = styled.div<ContainerProps>`
  width: fit-content;
  padding: 4px 12px;
  border-radius: 20px;
  background: ${(props) => props.bg};

  p {
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    color: #fff8f7;
  }
`;

export default Container;
